import { CpuArch } from '../api';

import type { FreeTierItem, FreeTierListResponse } from '../api';

export const FreeTierResource = {
  FE: 1,
  BE: 2,
  WAREHOUSE: 3,
} as const;
export type FreeTierResource = (typeof FreeTierResource)[keyof typeof FreeTierResource];

export interface FreeTierOffer {
  fe?: FreeTierItem;
  be?: FreeTierItem;
  warehouse?: FreeTierItem;
}

export function freeTierOffers(res: FreeTierListResponse | undefined): FreeTierOffer[] {
  return (res?.FreeTiers ?? []).map((tier) => {
    const of = (type: FreeTierResource): FreeTierItem | undefined =>
      (tier.items ?? []).find((item) => item.resource_type === type);
    return {
      fe: of(FreeTierResource.FE),
      be: of(FreeTierResource.BE),
      warehouse: of(FreeTierResource.WAREHOUSE),
    };
  });
}

export interface FreeTierSelection {
  /** The node id out of the coordinator's composite key, not the key itself. */
  feVmCategoryId: string;
  feCount: number;
  beVmCategoryId: string;
  beCount: number;
  elastic: boolean;
  arch?: string;
}

/** A tier covers an exact shape, not a ceiling; elastic workers match the warehouse allowance. */
export function matchesFreeTier(offers: FreeTierOffer[], selection: FreeTierSelection): boolean {
  // arm64 is never free.
  if (selection.arch === CpuArch.ARM64) return false;

  return offers.some((offer) => {
    const worker = selection.elastic ? offer.warehouse : offer.be;
    if (!offer.fe || !worker) return false;
    return (
      offer.fe.num === selection.feCount &&
      offer.fe.vm_category_id === selection.feVmCategoryId &&
      worker.num === selection.beCount &&
      worker.vm_category_id === selection.beVmCategoryId
    );
  });
}
